import React from 'react';
import { motion } from 'framer-motion';
import { getCategoryStatus } from '../utils/scoreCalculator';
import styles from './AreaRiskChart.module.css';

const CHART_WIDTH = 640;
const ROW_HEIGHT = 46;
const TOP_PADDING = 14;
const BOTTOM_PADDING = 10;
const LABEL_WIDTH = 168;
const TRACK_WIDTH = CHART_WIDTH - LABEL_WIDTH - 60;
const TRACK_X = LABEL_WIDTH;

const ZONES = [
  { from: 0, to: 40, fill: 'rgba(217, 67, 60, 0.08)' },
  { from: 40, to: 70, fill: 'rgba(201, 134, 26, 0.08)' },
  { from: 70, to: 100, fill: 'rgba(31, 157, 99, 0.08)' },
];

export default function AreaRiskChart({ categories }) {
  const height = TOP_PADDING + categories.length * ROW_HEIGHT + BOTTOM_PADDING;

  return (
    <div className={`${styles.chartCard} aira-card`}>
      <div className={styles.headerRow}>
        <h3 className={styles.title}>Area Risk Overview</h3>
        <div className={styles.legend}>
          <span className={styles.legendItem}>
            <span className={styles.dot} style={{ background: '#1F9D63' }} />
            Safe
          </span>
          <span className={styles.legendItem}>
            <span className={styles.dot} style={{ background: '#C9861A' }} />
            Moderate
          </span>
          <span className={styles.legendItem}>
            <span className={styles.dot} style={{ background: '#D9433C' }} />
            Critical
          </span>
        </div>
      </div>

      <svg width="100%" viewBox={`0 0 ${CHART_WIDTH} ${height}`} className={styles.svg}>
        {ZONES.map((zone) => {
          const x = TRACK_X + (zone.from / 100) * TRACK_WIDTH;
          const w = ((zone.to - zone.from) / 100) * TRACK_WIDTH;
          return (
            <rect
              key={zone.from}
              x={x}
              y={0}
              width={w}
              height={height}
              fill={zone.fill}
            />
          );
        })}

        {[0, 25, 50, 75, 100].map((tick) => {
          const x = TRACK_X + (tick / 100) * TRACK_WIDTH;
          return (
            <line
              key={tick}
              x1={x}
              y1={0}
              x2={x}
              y2={height}
              stroke="rgba(15, 23, 42, 0.08)"
              strokeWidth={1}
            />
          );
        })}

        {categories.map((cat, i) => {
          const status = getCategoryStatus(cat.score);
          const y = TOP_PADDING + i * ROW_HEIGHT;
          const barY = y + 10;
          const barHeight = 18;
          const barWidth = (cat.score / 100) * TRACK_WIDTH;

          return (
            <g key={cat.key}>
              <text
                x={0}
                y={barY + barHeight / 2}
                dominantBaseline="middle"
                className={styles.rowLabel}
              >
                {cat.label}
              </text>

              <rect
                x={TRACK_X}
                y={barY}
                width={TRACK_WIDTH}
                height={barHeight}
                rx={barHeight / 2}
                fill="rgba(15, 23, 42, 0.05)"
              />

              <motion.rect
                x={TRACK_X}
                y={barY}
                height={barHeight}
                rx={barHeight / 2}
                fill={status.color}
                initial={{ width: 0 }}
                animate={{ width: barWidth }}
                transition={{ duration: 0.8, ease: 'easeOut', delay: 0.15 + i * 0.06 }}
              />

              <text
                x={TRACK_X + TRACK_WIDTH + 12}
                y={barY + barHeight / 2}
                dominantBaseline="middle"
                className={styles.scoreLabel}
              >
                {cat.score}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
